export default {"src":"/_next/static/media/laptop-minor.57f81e07.svg","height":71,"width":113};